import { getAccessToken, getPaymentsForm, getPaymentStatusData } from '../../../selectors/biasharaFlexi/payment';
import { getIsApiPending } from '../../../selectors/biasharaFlexi/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/biasharaFlexi/payloadCollection';
import { getCompanyIdValue, getQuoteIdValue } from '../../../selectors/biasharaFlexi/companyDetails';
import { triggerConfirmOrder } from '../../../actions/biasharaFlexi/payment';
import axios from 'axios';

export const savePayments = (store, next, action) => { 
    (async() => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                const resp = await makeSubmission(store.getState());
                // const payments = getPaymentsForm(store.getState());
                // const paymentsData = getPaymentStatusData(store.getState());

                if (resp.data) {
                    store.dispatch(apiTransitionPayloadCollection.success());
                    // if(payments?.networkProvider.value === 'mpesa' && paymentsData?.message === 'Success') {
                    //     store.dispatch(triggerConfirmOrder())
                    // }
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPayloadCollection.initial());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const cid = getCompanyIdValue(state);
    const qid = getQuoteIdValue(state);
    const payments = getPaymentsForm(state);
    
    const payload = {
        companyId: cid.value,
        quoteId: qid.value,
        mpesaPhoneNumber: 'N/A',
        modeOfPayment: payments?.networkProvider.value === 'mpesa' ? 'Mpesa' : 'Bank'
    }

    return {
        ...payload
    }
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/biashara-flexi/save-payment-details';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};

export const saveFailedPayments = (store, next, action) => { 
    (async() => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                await makeSubmission(store.getState());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
    })();
    return next(action);
};